/* 13 個種子主類別 ＋ 系統保留的「未分類」。
   預設複習天數來自 docs/01-流程設計文件.md §3.2。使用者可改名、刪除、新增。 */
import type { Category } from "./types.ts";

interface Seed { key: string; name: string; reviewDefaultDays: number; definition?: string }

const SEEDS: Seed[] = [
  { key: "natural", name: "自然科學", reviewDefaultDays: 730 },
  { key: "life", name: "生命科學", reviewDefaultDays: 730 },
  { key: "medicine", name: "醫學與健康", reviewDefaultDays: 365 },
  { key: "math", name: "數學", reviewDefaultDays: 1825 },
  { key: "engineering", name: "工程與技術", reviewDefaultDays: 730 },
  { key: "cs", name: "資訊與程式", reviewDefaultDays: 180 },
  { key: "social", name: "社會科學", reviewDefaultDays: 730 },
  { key: "history", name: "歷史與人文", reviewDefaultDays: 1825 },
  { key: "language", name: "語言", reviewDefaultDays: 365 },
  { key: "business", name: "商業與經濟", reviewDefaultDays: 365 },
  { key: "law", name: "法律與制度", reviewDefaultDays: 365 },
  { key: "art", name: "藝術與設計", reviewDefaultDays: 1095 },
  { key: "lifeSkills", name: "生活與技能", reviewDefaultDays: 365 },
];

export const UNCATEGORIZED_NAME = "未分類";
export const UNCATEGORIZED_ID = "cat-uncategorized";

/** 類別 id 由 seedKey 決定，**不是**隨機的 ——
    否則每台裝置的「生命科學」會是不同的 id，同步過去的知識會放不進任何抽屜。 */
export function seedCategoryId(key: string): string {
  return "cat-" + key;
}

export function buildSeedCategories(now: number): Category[] {
  const list: Category[] = SEEDS.map((s, i) => ({
    id: seedCategoryId(s.key),
    parentId: null,
    seedKey: s.key,
    name: s.name,
    definition: s.definition ?? "",
    reviewDefaultDays: s.reviewDefaultDays,
    linkCapPerNode: 12,
    sortOrder: i,
    system: false,
    createdAt: now,
    updatedAt: now,
    deletedAt: null,
    rev: 1,
  }));
  list.push({
    id: UNCATEGORIZED_ID, parentId: null, seedKey: "uncategorized", name: UNCATEGORIZED_NAME,
    definition: "還沒決定放哪裡。它們會出現在重新測定的佇列裡提醒你。",
    reviewDefaultDays: 180, linkCapPerNode: 12, sortOrder: 99, system: true,
    createdAt: now, updatedAt: now, deletedAt: null, rev: 1,
  });
  return list;
}

export const SEED_NAMES = SEEDS.map((s) => s.name);

/** seedKey → 當初種下時的中文名。用來判斷類別有沒有被使用者改過名。 */
/** 舊版是隨機 id，這裡留一個查表讓測試與除錯方便。 */
export function buildSeedCategoriesRandom(now: number, idFor: (name: string) => string): Category[] {
  return buildSeedCategories(now).map((c) => ({ ...c, id: idFor(c.name) }));
}

export function seedOriginalName(key: string): string | undefined {
  if (key === "uncategorized") return UNCATEGORIZED_NAME;
  return SEEDS.find((s) => s.key === key)?.name;
}
